import { Component, OnInit, Input } from '@angular/core';
import { serie } from 'src/model/Serie';
import { AngularFirestore } from 'angularfire2/firestore';
import { ModalController, AlertController, NavController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AddTiratorePage } from '../addtiratore/addtiratore.page';

@Component({
  selector: 'app-creaserie',
  templateUrl: './creaserie.page.html',
  styleUrls: ['./creaserie.page.scss'],
})
export class CreaseriePage implements OnInit {
  serie: serie = new serie();
  validations_form: FormGroup;
  @Input() idgara: string;
  @Input() action: string;
  @Input() idserie: string;
  constructor(private fireStore: AngularFirestore, public navCtrl: NavController, public modalController: ModalController, public modal: ModalController, private alertController: AlertController) { }

  ngOnInit() {
    this.serie.tiratori = [];
    //console.logthis.action);
    this.validations_form = new FormGroup({
      // nome: new FormControl(),
      data_a: new FormControl(),
      campo: new FormControl(),
      tiratore1: new FormControl(),
      tiratore2: new FormControl(),
      tiratore3: new FormControl(),
      tiratore4: new FormControl(),
      tiratore5: new FormControl(),
      tiratore6: new FormControl(),
      data_da: new FormControl()
    });
    if (this.action == 'mod') {
      //console.log'get', this.idserie);

      this.fireStore.collection<any>('serie').doc(this.idserie).get().subscribe((r) => {
        //console.logr.data().data);
        this.validations_form.controls.data_da.setValue(r.data().data_da);
        this.validations_form.controls.campo.setValue(r.data().campo);
        this.validations_form.controls.data_a.setValue(r.data().data_a);
        for (let i = 0; i < 6; i++) {
          if (r.data().tiratori && r.data().tiratori[i] != undefined && r.data().tiratori[i] != null)
            this.serie.tiratori[i] = r.data().tiratori[i];
        }

        // this.validations_form.controls.tiratore1.setValue(r.data().tiratori[0]);
        // this.validations_form.controls.tiratore2.setValue(r.data().tiratori[1]);
        // this.validations_form.controls.tiratore3.setValue(r.data().tiratori[2]);
        // this.validations_form.controls.tiratore4.setValue(r.data().tiratori[3]);
        // this.validations_form.controls.tiratore5.setValue(r.data().tiratori[4]);
        // this.validations_form.controls.tiratore6.setValue(r.data().tiratori[5]);
        // this.validations_form.setValue({data:r.data().data,schema:r.data().schema});

      })


    }
  }

  close() {
    this.modal.dismiss();
  }
  crea() {

    // this.serie.tiratori = [];
    this.serie.data_da = this.validations_form.value.data_da;
    this.serie.data_a = this.validations_form.value.data_a;
    this.serie.campo = this.validations_form.value.campo;
    // this.serie.tiratori[0] = this.validations_form.value.tiratore1;
    // //console.logthis.validations_form.value.tiratore2);
    // if (this.validations_form.value.tiratore2 != null && this.validations_form.value.tiratore2 != '')
    //   this.serie.tiratori[1] = this.validations_form.value.tiratore2;
    // if (this.validations_form.value.tiratore3 != null && this.validations_form.value.tiratore3 != '')
    //   this.serie.tiratori[2] = this.validations_form.value.tiratore3;
    // if (this.validations_form.value.tiratore4 != null && this.validations_form.value.tiratore4 != '')
    //   this.serie.tiratori[3] = this.validations_form.value.tiratore4;
    // if (this.validations_form.value.tiratore5 != null && this.validations_form.value.tiratore5 != '')
    //   this.serie.tiratori[4] = this.validations_form.value.tiratore5;
    // if (this.validations_form.value.tiratore6 != null && this.validations_form.value.tiratore6 != '')
    //   this.serie.tiratori[5] = this.validations_form.value.tiratore6;
    this.serie.punteggi = [];
    this.serie.tiratore1 = [];
    this.serie.tiratore2 = [];
    this.serie.tiratore3 = [];
    this.serie.tiratore4 = [];
    this.serie.tiratore5 = [];
    this.serie.tiratore6 = [];
    this.serie.id_gara = this.idgara;
    // //console.log.value);
    let obj = {};
    for (let p in this.serie) {
      obj[p] = this.serie[p];
    }
    if (this.serie.data_a != '' && this.serie.data_a != null && this.serie.data_a != undefined && this.serie.data_da != '' && this.serie.data_da != null && this.serie.data_da != undefined) {
      if (this.action == 'mod') {
        this.fireStore.collection<any>('serie').doc(this.idserie).update(obj).then(() => {
          this.presentAlert();
          this.modal.dismiss();
        })
      }
      else {
        this.fireStore.collection<any>('serie').add(obj).then(() => {
          this.presentAlert();
          this.modal.dismiss();
        })
      }
    }
    else{
      alert('inserisci tutti i campi delle date "da" "a" ');
    }
  }
  delete_tiratore(number) {
    this.serie.tiratori.splice(number, 1);
  }

  async add_tiratore(tiratore) {
    // this.navCtrl.navigateForward('addtiratore');
    const modal = await this.modalController.create({
      component: AddTiratorePage,
      componentProps: tiratore
    });
    modal.present();

    const { data } = await modal.onWillDismiss();
    if (data != null && data != undefined) {
      if (this.containscognomenome(data.cognome + ' ' + data.nome, this.serie.tiratori)) {
        this.presentError();
      }
      else
        this.serie.tiratori[tiratore] = data;
    }



  }
  containscognomenome(cognomenome, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].cognome + ' ' + list[i].nome === cognomenome) {
        return true;
      }
    }
    return false;
  }

  async presentError() {
    let obj_alert = {
      header: 'Aggiunta Tiratore',
      subHeader: 'Errore',
      message: 'Il tiratore è già presente nella batteria',
      buttons: ['OK']
    }

    const alert = await this.alertController.create(obj_alert);

    await alert.present();
  }

  async presentAlert() {

    if (this.action == 'mod') {
      let obj_alert = {
        header: 'Serie',
        subHeader: 'Modifica',
        message: 'Serie modificata con successo',
        buttons: ['OK']
      }
      const alert = await this.alertController.create(obj_alert);

      await alert.present();
    }
    else {
      let obj_alert = {
        header: 'Serie',
        subHeader: 'Creazione',
        message: 'Serie creata con successo',
        buttons: ['OK']
      }
      const alert = await this.alertController.create(obj_alert);

      await alert.present();
    }

  }

}
